import { supabase } from "./api";

export async function uploadFile(filename, file) {
  const { data, error } = await supabase.storage
    .from("editorfile")
    .upload(filename, file, {
      upsert: true,
    });
  console.log("uploadFile", data, error);
}

export async function getFile(filename) {
  const { data, error } = await supabase.storage
    .from("editorfile")
    .getPublicUrl(filename);

  return data;
}

export async function removeFile(filename) {
  const { data, error } = await supabase.storage
    .from("editorfile")
    .remove([filename]);
}
